<template>
  <div class="boss-search-preview-wrap">
    <div class="boss-search-preview">
      <div class="boss-layout boss-layout-vertical">
        <template v-if="isSearching">
          <div
            class="loader-mini"
            data-test="loader"
          />
        </template>
        <template v-else>
          <div>
            <div class="boss-layout boss-layout-gap-small boss-layout-search-preview">
              <div
                class="boss-search-preview-result"
                data-test="hit-num"
              >
                <template v-if="isError">
                  －
                </template>
                <template v-else>
                  {{ hit.num | hitOmit }}
                </template>
              </div>
              <div class="boss-search-preview-text">
                名
              </div>
            </div>
          </div>
          <div>
            <button
              v-if="isSearchable"
              :disabled="(isCheckedSaveSearch && isEmptySearchConditionName) || isError"
              type="button"
              class="boss-button boss-button-fill pega-button pega-width-100-percent"
              data-test="search-button"
              @click="search"
            >
              <span class="boss-button-before boss-icon-triangle" />
              <span
                class="boss-button-text"
                data-test="search-button-text"
              >
                <template v-if="searchConditionId">
                  保存して検索する
                </template>
                <template v-else-if="isCheckedSaveSearch">
                  検索条件を保存して検索する
                </template>
                <template v-else>
                  検索する
                </template>
              </span>
            </button>
            <div
              v-else
              class="boss-search-preview-alert"
              data-test="over-hit"
            >
              1000名以上ヒットしています。
              <br>条件を絞って下さい
            </div>
          </div>
        </template>
        <div>
          <label class="pega-input">
            <input
              v-model="isCheckedSaveSearch"
              type="checkbox"
              class="boss-input-checkbox"
              data-test="save-search-checkbox"
            >検索条件に名前を付けて保存する
          </label>
        </div>
        <div>
          <input
            v-model="searchConditionName"
            :disabled="!isCheckedSaveSearch"
            :class="{'is-invalid-input': isCheckedSaveSearch && isEmptySearchConditionName}"
            type="text"
            class="boss-input boss-input-fill"
            placeholder="検索条件名を入力"
            data-test="save-search-condition-name"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  filters: {
    hitOmit (val) {
      return (val < 1000) ? val.toString() : '999+'
    }
  },
  props: {
    searchCount: {
      type: Number,
      default: null
    },
    searchConditionId: {
      type: Number,
      default: null
    },
    conditionName: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCheckedSaveSearch: false,
      isSearchable: false,
      hit: {
        num: 0
      },
      searchConditionName: this.conditionName
    }
  },
  computed: {
    isEmptySearchConditionName () {
      return this.searchConditionName.length === 0
    }
  },
  watch: {
    searchCount (val) {
      this.toggleSearchable(val)
      this.updateHitCount(val)
    }
  },
  methods: {
    toggleSearchable (number) {
      this.isSearchable = (number < 1000)
    },
    updateHitCount (number) {
      anime({
        targets: this.hit,
        num: number,
        round: 1,
        duration: 1000,
        easing: 'easeOutCubic'
      })
    },
    search () {
      if (this.isCheckedSaveSearch || this.searchConditionId) {
        return this.$emit('search', this.searchConditionName)
      } else {
        return this.$emit('search', '')
      }
    }
  }
}
</script>
